import React, { Suspense, useEffect, useState } from 'react'
import { IdleQueue } from '../../lib/idlize/IdleQueue.mjs'

const LazyRoutedModal = React.lazy(() => import('./routed-modal'))

const modalLoadingQueue = new IdleQueue({
  defaultMinTaskTime: 5
})

/**
 * Defers loading the routed-modal bundle until the browser is idle, then renders it lazily.
 */
function AsyncModal(props) {
  const [loadScripts, setLoadScripts] = useState(false)

  useEffect(() => {
    // The idle task may run after unmounting, so guard against updating stale component state.
    let isMounted = true

    modalLoadingQueue.pushTask(() => {
      if (isMounted) setLoadScripts(true)
    })

    return () => {
      isMounted = false
    }
  }, [])

  if (!loadScripts) return null

  return (
    <Suspense fallback={null}>
      <LazyRoutedModal {...props} />
    </Suspense>
  )
}

export default AsyncModal
